import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

import { Business, BusinessSearchCommand } from '../../models/business';
import { ApiResponse, PaginatedApiResponse } from '@card-software/nexus-utilities';

@Injectable({ providedIn: 'root' })
export class BusinessProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.financeApi + '/api/v1/business';

  public createBusiness(data: Business): Observable<ApiResponse<Business>> {
    return this.httpClient.post<ApiResponse<Business>>(this.baseUrl, data);
  }

  public updateBusiness(id: string, data: Business): Observable<ApiResponse<Business>> {
    return this.httpClient.put<ApiResponse<Business>>(this.baseUrl + '/' + id, data);
  }

  public getBusinessById(id: string): Observable<ApiResponse<Business>> {
    return this.httpClient.get<ApiResponse<Business>>(this.baseUrl + '/' + id);
  }

  public search(searchCommand: BusinessSearchCommand): Observable<ApiResponse<PaginatedApiResponse<Business>>> {
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<Business>>>(this.baseUrl + '/search', searchCommand);
  }
}
